import React, { useEffect } from "react";
import Vimeo from "@u-wave/react-vimeo";
import { useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Col, Card, Tag } from "antd";
import styled from "styled-components";
import VideoCompleteModel from "./VideoCompleteModel";
import mailSchedular from "../../../services/mailSchedular";
import parseJwt from "../../../utils/parseJwt";


// Enhanced styled components for visual appeal
const StyledCard = styled(Card)`
  width: 100%;
  border-radius: 16px;
  margin:auto;
  margin-top:30px;
  align-items:center;
  overflow: hidden;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(0, 0, 0, 0.05);
  background: #ffffff;
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 35px -5px rgba(0, 0, 0, 0.15), 0 15px 15px -5px rgba(0, 0, 0, 0.08);
  }

  .ant-card-body {
    padding: 24px;
  }

  .ant-card-cover {
    position: relative;
    overflow: hidden;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 60px;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.3), transparent);
      pointer-events: none;
    }
  }
`;

const VideoTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: var(--primary-text-color);
  margin-bottom: 8px;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const VideoDescription = styled.p`
  font-size: 15px;
  color: var(--secondary-text-color);
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 16px;
`;

const PublicVideoPage = () => {
  const [videoIframe, setVideoIframe] = useState("");
  const [isError, setIsError] = useState(false);
  const [videoDetails, setVideoDetails] = useState({})
  const videoToken = useParams().videoToken;
  const [isVideoCompleted, setIsVideoCompleted] = useState(false);


  useEffect(() =>{
    if(videoToken){
      const videoDetails = parseJwt(videoToken)
      setVideoIframe(videoDetails?.videoUrl)
      setVideoDetails(videoDetails)
    }

  },[videoToken])

  const onVideoComplete = async () => {
    try {
      const res = await mailSchedular.markWatched(videoToken)
      if (res.status === 200) {
        setIsVideoCompleted(true)
      }
    }
    catch (err) {

    }
  }

  return (
    <>
      {isVideoCompleted && (
        <VideoCompleteModel
          isOpen={isVideoCompleted}
          setOpen={setIsVideoCompleted}
        />
      )}
      <StyledCard
        cover={
          <Col className="p-0" style={{ width: '100%' }}>
            <div className="relative w-100">
              {videoIframe ? (
                <div
                  style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}
                >
                  {isError ? (
                    <div>Video is prepraing</div>
                  ) : (
                    <Vimeo
                      onEnd={onVideoComplete}
                      video={videoIframe}
                      autoplay={false}
                      showTitle={false}
                      showByline={false}
                      showPortrait={false}
                      responsive={true}
                      onError={(error) => setIsError(true)}
                      // fullscreen={true}
                      style={{
                        width: "100%",
                        aspectRatio: "16/9",
                        objectFit: "cover",
                        borderRadius: "10px",
                        border: "1px solid var(--border-color)",
                      }}
                    />
                  )}
                </div>
              ) : (
                <div style={{ textAlign: "center", padding: "40px" }}>
                  {/* Invalid video URL */}
                  Fetching Video ...
                </div>
              )}
            </div>
          </Col>
        }
      >
        <VideoTitle>{videoDetails?.videoName}</VideoTitle>
        <VideoDescription>{videoDetails?.description}</VideoDescription>
        <VideoDescription>{videoDetails?.specialty && <Tag>{videoDetails?.specialty}</Tag>}</VideoDescription>

      </StyledCard>
    </>
  );
};

export default PublicVideoPage;